
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/plugin-latex.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-plugin-latex-demo-basic","docs-x-markdown-plugin-latex-demo-streaming"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/plugin-latex.zh-CN.md?type=demo')
};